// import '@aws-amplify/ui-react/styles.css';
import { Flex, View, Card, Text } from '@aws-amplify/ui-react';
import { Sparkline } from './Sparkline';

function roundToDigits(number, digits) {
  return Number.parseFloat(number).toFixed(digits);
}

// Fix the error checking here:
export function StatBox({ my_data, metric_name }) {
  if (my_data && my_data.length > 0) {
    const latestMetricArray = my_data?.slice(-1)[0]?.metrics[metric_name];
    if (latestMetricArray) {
      const [time, metName, val, unit, min, max] = latestMetricArray;
      return (
        <View>
          <Card backgroundColor="#B0B0B0" borderRadius="5px" width="150px">
            <Flex direction="column" alignItems="center">
              <Flex>{metName}</Flex>
              <Flex direction="column">
                <span>{val ? roundToDigits(val, 1) : '-'}</span>
                <span>{unit}</span>
                <span>
                  min:{min} max:{max}
                </span>
              </Flex>
              <Flex>
                <Sparkline
                  my_data={my_data}
                  metric_name={metric_name}
                  suggested_min={min}
                  suggested_max={max}
                ></Sparkline>
              </Flex>
            </Flex>
          </Card>
        </View>
      );
    }
  }
}
